import { RenderContainer } from "../RenderContainer";
import React from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import { ErrorM } from "components/helpers/FormHelpers/ErrorM";
import { useField } from "formik";

const CustomString: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField,
}) => {
  const [{ value }] = useField(field.name);
  const booleanString =
    booleanField && readOnly
      ? customField.value === "True"
        ? "Yes"
        : "No"
      : null;

  // guard against null or undefined
  const raw = booleanString !== null
    ? booleanString
    : (value[index]?.value as string)  
  const inputValue = raw ?? "";

  return (
    <RenderContainer
      customFieldName={customField.name}
      classWrapper={classWrapper}
      orderNumber={customField.orderNumber}
    >
      <React.Fragment>
        {handleOnChange && (
          <>
            <input
              className={`EditBox${readOnly ? " ViewOnly" : ""} ${
                classWrapper || ""
              }`}
              value={inputValue}
              readOnly={readOnly}
              onChange={e => handleOnChange(e, index)}
            />
            <ErrorM name={customField.name} />
          </>
        )}
      </React.Fragment>
    </RenderContainer>
  );
};

export const customString: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomString
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
